import * as React from "react";
import { useTranslation } from "react-i18next";
import {
  Button,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Box,
  Stack,
  Typography,
  Autocomplete,
} from "@mui/material/";
import CloseIcon from "@mui/icons-material/Close";
import { useFormik } from "formik";
import * as yup from "yup";
import { string } from "yup";
import AutoComplete from "../common/AutoComplete";
import EnumChangeName from "../common/EnumChangeName";
import { AutoCompleteOption } from "../common/AutoComplete";
import { useMemo } from "react";

export interface ValuesStatusReasonObject {
  code?: string;
  descr: string;
  status?: string;
  valid: string;
  id?: string;
  transferable?: string;
  damages?:string;
}
export const AddNewStatusReasons = (props: any) => {
  const createNewStatusReason = props.createNewStatusReason;
  const getByCodeStatusReason = props.getByCodeStatusReason;
  const { t } = useTranslation(["operation"]);
  const handleClose = () => {
    props.setStatusReasonDataForm({
      code: "",
      descr: "",
      status: "",
      valid: "",
      transferable: "",
      damages:"",
      id: "",
    });
    props.setOpenAddDialog(false);
  };
  const arrayStatusReason = ["AVAILABLE", "NOT_AVAILABLE"];
  const arrayValidityReason = ["true", "false"];

  const transferable: AutoCompleteOption[] = [
    {
      value: true,
      label: t("internOptionSelectName.yes"),
    },
    {
      value: false,
      label: t("internOptionSelectName.no"),
    },
  ];

  const changeStatusName = (option: any) => {
    switch (option) {
      case "AVAILABLE":
        return t("internOptionSelectName.available");
      case "NOT_AVAILABLE":
        return t("internOptionSelectName.notAvailable");
      default:
        return "";
    }
  };
  const changeValidityName = (option: string) => {
    switch (option) {
      case "true":
        return t("internOptionSelectName.valid");
      case "false":
        return t("internOptionSelectName.inValid");
      default:
        return "";
    }
  };
  const changeTransferableName = (option: string) => {
    switch (option) {
      case "true":
        return t("internOptionSelectName.yes");
      case "false":
        return t("internOptionSelectName.no");
      default:
        return "";
    }
  };
  let validationSchemaStatusReason = {};

  if (!props.getStatusReasonDataForm.id) {
    validationSchemaStatusReason = yup.object({
      code: string()
        .required(t("statusReason.addRecord.requiredCode"))
        .matches(
          /[^%*$)(\"+&?^~Â`£=!@'_/§#-].{0,}/,
          t("vehicle.filterModal.regexMessage")
        )
        .test(
          "Unique Code",
          t("statusReason.addRecord.testCode"),
          function (code) {
            return getByCodeStatusReason(code);
          }
        ),

      descr: string()
        .required(t("statusReason.addRecord.requiredDescription"))
        .matches(
          /[^%*$)(\"+&?^~Â`£=!@'_/§#-].{0,}/,
          t("vehicle.filterModal.regexMessage")
        ),
      status: string()
        .required(t("statusReason.addRecord.requiredStatus"))
        .typeError(t("statusReason.addRecord.requiredStatus")),
      valid: string()
        .required(t("statusReason.addRecord.requiredValid"))
        .typeError(t("statusReason.addRecord.requiredValid")),
      transferable: string()
        .required(t("statusReason.addRecord.requiredTransferable"))
        .typeError(t("statusReason.addRecord.requiredTransferable")),
        damages: string()
        .required(t("statusReason.addRecord.requiredDamages"))
        .typeError(t("statusReason.addRecord.requiredDamages")),
    });
  } else {
    validationSchemaStatusReason = yup.object({
      descr: string()
        .required(t("statusReason.addRecord.requiredDescription"))
        .matches(
          /[^%*$)(\"+&?^~Â`£=!@'_/§#-].{0,}/,
          t("vehicle.filterModal.regexMessage")
        ),
      valid: string()
        .required(t("statusReason.addRecord.requiredValid"))
        .typeError(t("statusReason.addRecord.requiredValid")),
      transferable: string()
        .required(t("statusReason.addRecord.requiredTransferable"))
        .typeError(t("statusReason.addRecord.requiredTransferable")),
        damages: string()
        .required(t("statusReason.addRecord.requiredDamages"))
        .typeError(t("statusReason.addRecord.requiredDamages")),
    });
  }
  const formikStatusReasonObject = useFormik({
    initialValues: {
      code: props.getStatusReasonDataForm.code,
      descr: props.getStatusReasonDataForm.descr,
      status: props.getStatusReasonDataForm.status,
      valid: props.getStatusReasonDataForm.valid.toString(),
      transferable: props.getStatusReasonDataForm.transferable.toString(),
      damages:props.getStatusReasonDataForm.damages.toString(),
      id: props.getStatusReasonDataForm.id
        ? `${props.getStatusReasonDataForm.id}`
        : "",
    },
    validationSchema: validationSchemaStatusReason,
    validateOnChange: false,
    onSubmit: (values: ValuesStatusReasonObject) => {
      props.createOrEditStatusReason(values);
      return handleClose();
    },
  });

  return (
    <>
      <Box>
        <form
          id="statusReasonForm"
          onSubmit={formikStatusReasonObject.handleSubmit}
        >
          <Dialog
            fullWidth={true}
            PaperProps={{
              sx: {
                maxWidth: "1161px !important",
                height: "357px",
                borderRadius: "4px",
              },
            }}
            open={props.openAddDialog}
            //onClose={handleClose}
          >
            <DialogTitle>
              <Grid
                container
                alignItems="center"
                alignContent="center"
                direction="row"
              >
                {props.getStatusReasonDataForm.id ? (
                  <Grid item>
                    {t("statusReason.addRecord.editStatusReason")}
                  </Grid>
                ) : (
                  <Grid item>
                    {t("statusReason.addRecord.newStatusReason")}
                  </Grid>
                )}
                <Grid
                  xs
                  item
                  sx={{
                    justifyContent: "flex-end",
                    display: "flex",
                  }}
                >
                  <CloseIcon
                    color="disabled"
                    fontSize="small"
                    onClick={handleClose}
                  />
                </Grid>
              </Grid>
            </DialogTitle>

            <DialogContent
              sx={{ borderTop: "1px groove rgba(208, 208, 206, 1)" }}
            >
              <Grid
                container
                spacing={2.5}
                paddingTop={2.5}
                //alignItems="center"
                //alignContent='center'
                direction="row"
                columns={12}
              >
                <Grid xl={3} lg={3} md={6} xs={12} item>
                  <Box>
                    {/* <InputLabel className="carGenericFilterLabelClass">
                      {t("carRange.description")}
                    </InputLabel> */}
                    <TextField
                      fullWidth
                      id="descr"
                      name="descr"
                      label={t("carRange.description")}
                      //placeholder={t("carRange.descriptionLabel")}
                      value={formikStatusReasonObject.values.descr}
                      onChange={formikStatusReasonObject.handleChange}
                      error={
                        formikStatusReasonObject.touched.descr &&
                        Boolean(formikStatusReasonObject.errors.descr)
                      }
                      helperText={
                        formikStatusReasonObject.touched.descr &&
                        formikStatusReasonObject.errors.descr
                      }
                    />
                  </Box>
                </Grid>
                <Grid xl={3} lg={3} md={6} xs={12} item>
                  <Box>
                    <TextField
                      disabled={props.getStatusReasonDataForm.id ? true : false}
                      fullWidth
                      id="code"
                      name="code"
                      label={t("carRange.code")}
                      value={formikStatusReasonObject.values.code}
                      onChange={(e) => {
                        formikStatusReasonObject.setFieldValue(
                          "code",
                          e.currentTarget.value.toUpperCase()
                        );
                      }}
                      error={
                        formikStatusReasonObject.touched.code &&
                        Boolean(formikStatusReasonObject.errors.code)
                      }
                      helperText={
                        formikStatusReasonObject.touched.code &&
                        formikStatusReasonObject.errors.code
                      }
                    />
                  </Box>
                </Grid>
                <Grid xl={3} lg={3} md={6} xs={12} item>
                  <Box>
                    <Autocomplete
                      disableClearable
                      disabled={props.getStatusReasonDataForm.id ? true : false}
                      id="status"
                      value={formikStatusReasonObject.values.status}
                      options={arrayStatusReason.map((response) => response)}
                      getOptionLabel={(option) => changeStatusName(option)}
                      onChange={(event, value) => {
                        formikStatusReasonObject.setFieldValue("status", value);
                      }}
                      includeInputInList
                      renderOption={(props, option, state) => {
                        return (
                          <li {...props} key={props.id}>
                            {changeStatusName(option)}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(
                            formikStatusReasonObject.touched.status &&
                              formikStatusReasonObject.errors.status
                          )}
                          fullWidth
                          helperText={
                            formikStatusReasonObject.touched.status &&
                            formikStatusReasonObject.errors.status
                          }
                          label={t("statusReason.status")}
                          name="status"
                        />
                      )}
                    />
                  </Box>
                </Grid>

                <Grid xl={3} lg={3} md={6} xs={12} item>
                  <Box>
                    <Autocomplete
                      id="valid"
                      disableClearable
                      value={formikStatusReasonObject.values.valid}
                      options={arrayValidityReason}
                      getOptionLabel={(option) => changeValidityName(option)}
                      onChange={(event, value) => {
                        formikStatusReasonObject.setFieldValue("valid", value);
                      }}
                      includeInputInList
                      renderOption={(props, option, state) => {
                        return (
                          <li {...props} key={props.id}>
                            {changeValidityName(option)}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(
                            formikStatusReasonObject.touched.valid &&
                              formikStatusReasonObject.errors.valid
                          )}
                          fullWidth
                          helperText={
                            formikStatusReasonObject.touched.valid &&
                            formikStatusReasonObject.errors.valid
                          }
                          label={t("statusReason.validity")}
                          name="valid"
                        />
                      )}
                    />
                  </Box>
                </Grid>

                <Grid xl={3} lg={3} md={6} xs={12} item>
                  <Box>
                    <Autocomplete
                      id="transferable"
                      disableClearable
                      value={formikStatusReasonObject.values.transferable}
                      options={arrayValidityReason}
                      getOptionLabel={(option) =>
                        changeTransferableName(option)
                      }
                      onChange={(event, value) => {
                        formikStatusReasonObject.setFieldValue(
                          "transferable",
                          value
                        );
                      }}
                      includeInputInList
                      renderOption={(props, option, state) => {
                        return (
                          <li {...props} key={props.id}>
                            {changeTransferableName(option)}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(
                            formikStatusReasonObject.touched.transferable &&
                              formikStatusReasonObject.errors.transferable
                          )}
                          fullWidth
                          helperText={
                            formikStatusReasonObject.touched.transferable &&
                            formikStatusReasonObject.errors.transferable
                          }
                          label={t("statusReason.transferable")}
                          name="transferable"
                        />
                      )}
                    />
                  </Box>
                </Grid>
                 
                <Grid xl={3} lg={3} md={6} xs={12} item>
                  <Box>
                    <Autocomplete
                      id="damages"
                      disableClearable
                      value={formikStatusReasonObject.values.damages}
                      options={arrayValidityReason}
                      getOptionLabel={(option) =>
                        changeTransferableName(option)
                      }
                      onChange={(event, value) => {
                        formikStatusReasonObject.setFieldValue(
                          "damages",
                          value
                        );
                      }}
                      includeInputInList
                      renderOption={(props, option, state) => {
                        return (
                          <li {...props} key={props.id}>
                            {changeTransferableName(option)}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          error={Boolean(
                            formikStatusReasonObject.touched.damages &&
                              formikStatusReasonObject.errors.damages
                          )}
                          fullWidth
                          helperText={
                            formikStatusReasonObject.touched.damages &&
                            formikStatusReasonObject.errors.damages
                          }
                          label={t("statusReason.damages")}
                          name="damages"
                        />
                      )}
                    />
                  </Box>
                </Grid>

                <Grid xs="auto" item></Grid>
              </Grid>
            </DialogContent>
            <DialogActions>
              <Stack direction="row" spacing={2.875} p={1} mr={3.625}>
                <Button variant="outlined" size="medium" onClick={handleClose}>
                  <Typography
                    sx={{
                      textTransform: "capitalize",
                      fontWeight: 700,
                      lineHeight: 2.25,
                      color: "#C8017D",
                    }}
                    variant="subtitle1"
                  >
                    {t("actionButtons.cancel")}
                  </Typography>
                </Button>
                <Button
                  variant="contained"
                  size="medium"
                  type={"submit"}
                  form="statusReasonForm"
                  color="accent"
                >
                  <Typography
                    sx={{
                      textTransform: "capitalize",
                      fontWeight: 700,
                      lineHeight: 2.25,
                      color: "white",
                    }}
                    variant="subtitle1"
                  >
                    {t("actionButtons.save")}
                  </Typography>
                </Button>
              </Stack>
            </DialogActions>
          </Dialog>
        </form>
      </Box>
    </>
  );
};
